import Alpine from 'alpinejs';
import KeenSlider from 'keen-slider';

Alpine.data('slider', () => ({
  current: 0,
  slider: null,
  initCarousels() {
    this.current = 0;
    const carousels = document.querySelectorAll('.keen-slider-carousel');

    const that = this;

    carousels.forEach((el) => {
      this.slider = new KeenSlider(el, {
        slides: {
          spacing: 16,
          perView: 1.5,
          spacing: 16,
        },
        slideChanged(e) {
          that.current = e.track.details.abs + '';
        },
      });
    });
  },

  prevSlide() {
    this.slider.prev();
  },

  nextSlide() {
    this.slider.next();
  },

  changeSlide(slide) {
    this.slider.moveToIdx(+slide);
  },
}));

// GALLERY

function ThumbnailPlugin(main) {
  return (slider) => {
    function removeActive() {
      slider.slides.forEach((slide) => {
        slide.classList.remove('border-green-300');
      });
    }
    function addActive(idx) {
      slider.slides[idx].classList.add('border-green-300');
    }

    function addClickEvents() {
      slider.slides.forEach((slide, idx) => {
        slide.addEventListener('click', () => {
          main.moveToIdx(idx);
        });
      });
    }

    slider.on('created', () => {
      addActive(slider.track.details.rel);
      addClickEvents();
      main.on('animationStarted', (main) => {
        removeActive();
        const next = main.animator.targetIdx || 0;
        addActive(main.track.absToRel(next));
        slider.moveToIdx(Math.min(slider.track.details.maxIdx, next));
      });
    });
  };
}

Alpine.data('gallery', () => ({
  current: 0,
  slider: null,
  initCarousels() {
    this.current = 0;

    const that = this;

    this.slider = new KeenSlider(this.$refs.gallery, {
      rubberband: false,
      slideChanged(e) {
        that.current = e.track.details.abs + '';
      },
    });

    new KeenSlider(
      this.$refs.thumbnails,
      {
        initial: 0,
        slides: {
          perView: 2.1,
          spacing: 4,
        },
      },
      [ThumbnailPlugin(this.slider)]
    );
  },

  prevSlide() {
    this.slider.prev();
  },

  nextSlide() {
    this.slider.next();
  },

  changeSlide(slide) {
    this.slider.moveToIdx(+slide);
  },
}));

Alpine.data('recentArticles', () => ({
  current: 0,
  slider: null,
  initCarousels() {
    this.current = 0;

    const that = this;

    this.slider = new KeenSlider(this.$refs.slider, {
      loop: true,
      slideChanged(e) {
        that.current = e.track.details.abs + '';
      },
    });
  },

  prevSlide() {
    this.slider.prev();
  },

  nextSlide() {
    this.slider.next();
  },
}));
